import {
  fetchResource,
  fetchCollection,
  createResource,
  updateResource,
  deleteResource,
  performActionOnResource,
  baseRequest
} from './index'
import get from 'lodash/get'
import { workOrderSchema as schema } from '../schemas'
import FileSaver from 'file-saver'
import { ApiError } from 'redux-api-middleware'

const singleKey = 'workOrder'
const multipleKey = 'workOrders'

export const WORK_ORDERS_FOR_PERIOD_REQUEST = 'WORK_ORDERS_FOR_PERIOD_REQUEST'
export const WORK_ORDERS_FOR_PERIOD_SUCCESS = 'WORK_ORDERS_FOR_PERIOD_SUCCESS'
export const WORK_ORDERS_FOR_PERIOD_FAILURE = 'WORK_ORDERS_FOR_PERIOD_FAILURE'

export function loadWorkOrdersForPeriod(year, month, startDate, endDate) {
  return baseRequest({
    url: '/work_orders/for_period',
    method: 'GET',
    query: { startDate: startDate.toISOString(), endDate: endDate.toISOString() },
    actions: [ WORK_ORDERS_FOR_PERIOD_REQUEST, WORK_ORDERS_FOR_PERIOD_SUCCESS, WORK_ORDERS_FOR_PERIOD_FAILURE ],
    responseInterceptor: ({work_orders}) => {
      return {
        workOrders: work_orders,
        year,
        month,
      }
    }
  })
}

export const WORK_ORDER_SERVICINGS_CSV_REQUEST = 'WORK_ORDER_SERVICINGS_CSV_REQUEST'
export const WORK_ORDER_SERVICINGS_CSV_SUCCESS = 'WORK_ORDER_SERVICINGS_CSV_SUCCESS'
export const WORK_ORDER_SERVICINGS_CSV_FAILURE = 'WORK_ORDER_SERVICINGS_CSV_FAILURE'

export function downloadCSV (id) {
  return baseRequest({
    url: `/work_orders/${id}/servicings_csv`,
    method: 'GET',
    actions: [ WORK_ORDER_SERVICINGS_CSV_REQUEST, WORK_ORDER_SERVICINGS_CSV_SUCCESS, WORK_ORDER_SERVICINGS_CSV_FAILURE ],
    responseInterceptor: (data, response) => {
      let file = new File([data.result], data.filename, { type: "text/csv" })
      FileSaver.saveAs(file)
    }
  })
}

export const WORK_ORDERS_REQUEST = 'WORK_ORDERS_REQUEST'
export const WORK_ORDERS_SUCCESS = 'WORK_ORDERS_SUCCESS'
export const WORK_ORDERS_FAILURE = 'WORK_ORDERS_FAILURE'

function fetchWorkOrders (url, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [WORK_ORDERS_REQUEST, WORK_ORDERS_SUCCESS, WORK_ORDERS_FAILURE],
    schema,
    responseInterceptor: response => ({ ...response, reload })
  })
}

export function loadWorkOrders (nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = getState().pagination.workOrders
    
    if (!nextPage) {
      nextPageUrl = '/work_orders'
    }
    
    return dispatch(fetchWorkOrders(nextPageUrl, !nextPage))
  }
}

export const VALID_WORK_ORDERS_REQUEST = 'VALID_WORK_ORDERS_REQUEST'
export const VALID_WORK_ORDERS_SUCCESS = 'VALID_WORK_ORDERS_SUCCESS'
export const VALID_WORK_ORDERS_FAILURE = 'VALID_WORK_ORDERS_FAILURE'

function fetchValidWorkOrders (areaId, url, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [VALID_WORK_ORDERS_REQUEST, VALID_WORK_ORDERS_SUCCESS, VALID_WORK_ORDERS_FAILURE],
    schema,
    responseInterceptor: response => ({ ...response, areaId, reload })
  })
}

export function loadValidWorkOrders (areaId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.validWorkOrders.${areaId}`, {})
    
    if (!nextPage) {
      nextPageUrl = `/servicings/${areaId}/valid_work_orders`
    }
    
    return dispatch(fetchValidWorkOrders(areaId, nextPageUrl, !nextPage))
  }
}

export const TRANSFER_AREA_REQUEST = 'TRANSFER_AREA_REQUEST'
export const TRANSFER_AREA_SUCCESS = 'TRANSFER_AREA_SUCCESS'
export const TRANSFER_AREA_FAILURE = 'TRANSFER_AREA_FAILURE'

export function transferArea (areaId, workOrderId) {
  return performActionOnResource({
    url: `/servicings/${areaId}`,
    key: 'servicing',
    action: `/send_to_work_order/${workOrderId}`,
    actions: [ TRANSFER_AREA_REQUEST, TRANSFER_AREA_SUCCESS, TRANSFER_AREA_FAILURE ],
    responseInterceptor: response => ({ ...response })
  })
}


export const LOCATION_WORK_ORDERS_REQUEST = 'LOCATION_WORK_ORDERS_REQUEST'
export const LOCATION_WORK_ORDERS_SUCCESS = 'LOCATION_WORK_ORDERS_SUCCESS'
export const LOCATION_WORK_ORDERS_FAILURE = 'LOCATION_WORK_ORDERS_FAILURE'

function fetchWorkOrdersForLocation (url, locationId, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [LOCATION_WORK_ORDERS_REQUEST, LOCATION_WORK_ORDERS_SUCCESS, LOCATION_WORK_ORDERS_FAILURE],
    schema,
    responseInterceptor: response => ({ ...response, reload, locationId })
  })
}

export function loadWorkOrdersForLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.workOrdersByLocation.${locationId}`, {})
    
    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/work_orders`
    }
    
    return dispatch(fetchWorkOrdersForLocation(nextPageUrl, locationId, !nextPage))
  }
}

export const WORK_ORDER_REQUEST = 'WORK_ORDER_REQUEST'
export const WORK_ORDER_SUCCESS = 'WORK_ORDER_SUCCESS'
export const WORK_ORDER_FAILURE = 'WORK_ORDER_FAILURE'

export function fetchWorkOrder (workOrderId) {
  return fetchResource({
    url: `/work_orders/${workOrderId}`,
    key: singleKey,
    actions: [WORK_ORDER_REQUEST, WORK_ORDER_SUCCESS, WORK_ORDER_FAILURE],
    schema,
    errorInterceptor: (data, response) => {
      throw new ApiError(response.status, response.statusText, response)
    }
  })
}

export const LIVE_LOAD_WORK_ORDER = 'LIVE_LOAD_WORK_ORDER'

export function insertNewWorkOrder (workOrderId) {
  return (dispatch, getState) => (
    dispatch(fetchResource({
      url: `/work_orders/${workOrderId}`,
      key: singleKey,
      actions: [WORK_ORDER_REQUEST, WORK_ORDER_SUCCESS, WORK_ORDER_FAILURE],
      schema
    }))
    .then(() => dispatch({
      type: LIVE_LOAD_WORK_ORDER,
      payload: workOrderId
    }))
  )
}

export function removeDeletedWorkOrder (workOrderId) {
  return {
    type: DELETE_WORK_ORDER_SUCCESS,
    payload: { resourceId: workOrderId }
  }
}

export const CREATE_WORK_ORDER_REQUEST = 'CREATE_WORK_ORDER_REQUEST'
export const CREATE_WORK_ORDER_SUCCESS = 'CREATE_WORK_ORDER_SUCCESS'
export const CREATE_WORK_ORDER_FAILURE = 'CREATE_WORK_ORDER_FAILURE'

export function createWorkOrder (data, renew) {
  return createResource({
    url: '/work_orders',
    key: singleKey,
    actions: [CREATE_WORK_ORDER_REQUEST, CREATE_WORK_ORDER_SUCCESS, CREATE_WORK_ORDER_FAILURE],
    baseParams: { renew },
    schema,
    data
  })
}

export const UPDATE_WORK_ORDER_REQUEST = 'UPDATE_WORK_ORDER_REQUEST'
export const UPDATE_WORK_ORDER_SUCCESS = 'UPDATE_WORK_ORDER_SUCCESS'
export const UPDATE_WORK_ORDER_FAILURE = 'UPDATE_WORK_ORDER_FAILURE'

export function updateWorkOrder (workOrderId, data) {
  return updateResource({
    url: `/work_orders/${workOrderId}`,
    key: 'workOrder',
    schema,
    data,
    actions: [ UPDATE_WORK_ORDER_REQUEST, UPDATE_WORK_ORDER_SUCCESS, UPDATE_WORK_ORDER_FAILURE ]
  })
}

export const DELETE_WORK_ORDER_REQUEST = 'DELETE_WORK_ORDER_REQUEST'
export const DELETE_WORK_ORDER_SUCCESS = 'DELETE_WORK_ORDER_SUCCESS'
export const DELETE_WORK_ORDER_FAILURE = 'DELETE_WORK_ORDER_FAILURE'

export function deleteWorkOrder (workOrderId) {
  return deleteResource({
    url: `/work_orders/${workOrderId}`,
    actionPayload: { resourceId: workOrderId },
    actions: [ DELETE_WORK_ORDER_REQUEST, DELETE_WORK_ORDER_SUCCESS, DELETE_WORK_ORDER_FAILURE ]
  })
}

export const WORK_ORDER_SIGN_OFF_REQUEST = 'WORK_ORDER_SIGN_OFF_REQUEST'
export const WORK_ORDER_SIGN_OFF_SUCCESS = 'WORK_ORDER_SIGN_OFF_SUCCESS'
export const WORK_ORDER_SIGN_OFF_FAILURE = 'WORK_ORDER_SIGN_OFF_FAILURE'

export function signOffOnWorkOrder (workOrderId, data) {
  return performActionOnResource({
    url: `/work_orders/${workOrderId}`,
    key: 'workOrder',
    action: 'sign_off',
    schema,
    body: data,
    actions: [ WORK_ORDER_SIGN_OFF_REQUEST, WORK_ORDER_SIGN_OFF_SUCCESS, WORK_ORDER_SIGN_OFF_FAILURE ]
  })
}

export const WORK_ORDER_SEND_RECEIPT_EMAIL_REQUEST = 'WORK_ORDER_SEND_RECEIPT_EMAIL_REQUEST'
export const WORK_ORDER_SEND_RECEIPT_EMAIL_SUCCESS = 'WORK_ORDER_SEND_RECEIPT_EMAIL_SUCCESS'
export const WORK_ORDER_SEND_RECEIPT_EMAIL_FAILURE = 'WORK_ORDER_SEND_RECEIPT_EMAIL_FAILURE'

export function sendReceiptEmail (workOrderId, data) {
  return performActionOnResource({
    url: `/work_orders/${workOrderId}`,
    key: 'workOrder',
    action: 'send_receipt_email',
    schema,
    body: data,
    actions: [ WORK_ORDER_SEND_RECEIPT_EMAIL_REQUEST, WORK_ORDER_SEND_RECEIPT_EMAIL_SUCCESS, WORK_ORDER_SEND_RECEIPT_EMAIL_FAILURE ]
  })
}



// WEBPACK FOOTER //
// ./src/actions/work-orders.js